import Swiper, {Keyboard} from 'swiper';
Swiper.use([Keyboard]);

export default class CarouselArticles {
	constructor(elm) {
		this.elm = elm;

        this.swiperContainer = this.elm.querySelector('[data-swiper-container]');

		this.init();
	}

	init() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			slideClass: 'swiper-slide',
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			slidesPerView: 1,
			spaceBetween: window.innerWidth/20,
			grabCursor: true,
			touchEventsTarget: 'container',
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 42,
				},
				992: {
					slidesPerView: 2,
					spaceBetween: 42,
				},
			}
		});

		this.swiper.on('resize', (e) => {
			this.swiper.update();
		});

		this.swiper.init();
	}

}
